import $ from "jquery";

const miCaseStudy = () => {
    const init = () => {
        execute()
    }

    const execute = () => {
        const el = {
            main: '.js-cs-lists',
            projectInformation: {
                duration: '.js-cs-lists__duration .elementor-heading-title',
                freelancer: '.js-cs-lists__freelancer .elementor-heading-title',
                category: '.js-cs-lists__category .elementor-heading-title',
            },
            stack: '.js-cs-lists__stack',
            img: '.js-cs-lists__image img',
            challenges: '.js-cs-lists__challenges .elementor-image-box-description',
            solution: '.js-cs-lists__solution .elementor-image-box-description',
            result: '.js-cs-lists__result .elementor-image-box-description',
            review: {
                img: '.js-cs-lists__review__info img',
                name: '.js-cs-lists__review__info .elementor-image-box-title',
                role: '.js-cs-lists__review__info .elementor-image-box-description',
                message: '.js-cs-lists__review__message .elementor-heading-title',
            }
        }
        if ($(el.main).length === 0) return

        const fill = (data) => {
            $(el.projectInformation.duration).html(data.projectInformation.duration)
            $(el.projectInformation.freelancer).html(data.projectInformation.freelancer)
            $(el.projectInformation.category).html(data.projectInformation.category)
            $(el.stack).html(data.stack)
            $(el.img).attr('src', data.img)
            $(el.challenges).html(data.challenges)
            $(el.solution).html(data.solution)
            $(el.result).html(data.result)
            $(el.review.img).attr('src', data.review.img)
            $(el.review.message).html(data.review.message)
            $(el.review.name).html(data.review.name)
            $(el.review.role).html(data.review.role)

            console.log(data)
        }

        $(() => {
            const urlParams = new URLSearchParams(window.location.search)
            const fallstudien = urlParams.get("fallstudien")
            const main = fallstudien ? $(`#${fallstudien}`) : $(`${el.main}:first-child`)
            const data = main.data('data');

            $(el.main).removeClass("Active");
            main.addClass("Active");

            fill(data)
        })

        $(document).on("click", el.main, function () {
            const data = $(this).data('data');

            $(el.main).removeClass("Active");
            $(this).addClass("Active");

            fill(data)
        })
    }
    init()
}

try {
    miCaseStudy()
} catch (error) {
    console.error('miCaseStudy', error)
}